import React from "react";

const PartnerTerms = () => {
  return (
    <div
      style={{
        padding: "40px",
        
        margin: "auto",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.6",
        color: "#333",
      }}
    >
    
  <h1>Yovho Partner Promise</h1>
<p>Join <strong>Yovho</strong> today and become part of <strong>Pakistan&rsquo;s most trusted hospitality platform.</strong></p>
<h3>Start earning from your property today &mdash; even if you&rsquo;ve never run a hotel before.</h3>
<p><strong>Yovho</strong> is here to help you create a hospitality business, <strong>step by step</strong>.</p>
<hr />
<h3>We Build Your Business &mdash; Not Just List It</h3>
<p>At <strong>Yovho</strong>, we don&rsquo;t just list your property &mdash; we help you create a real <strong>hospitality business</strong>.</p>
<ul>
<li>
<p><strong>We Provide Trained Staff</strong></p>
<ul>
<li>
<p>If you don&rsquo;t have your own team, <strong>Yovho</strong> assigns trained <strong>housekeepers, receptionists, and support staff</strong>.</p>
</li>
<li>
<p>All team members are trained in <strong>hospitality, cleanliness, guest safety</strong>, and <strong>professional behavior</strong>.</p>
</li>
<li>
<p>Our <strong>training center</strong> ensures quality service at every property.</p>
</li>
</ul>
</li>
</ul>
<h3>Turn Your Property into Income</h3>
<p>Have an <strong>empty house</strong> or <strong>low-rent property</strong>?</p>
<p>We help you transform it into a verified stay by:</p>
<ul>
<li>
<p>Preparing it to meet <strong>hospitality standards</strong></p>
</li>
<li>
<p>Assigning a <strong>Yovho Captain</strong> to manage guest experience</p>
</li>
<li>
<p>Signing an agreement and managing operations</p>
</li>
</ul>
<p><strong>You earn passive income</strong> without needing to run the day-to-day.</p>
<hr />
<h3>Full Agreement for Safety and Transparency</h3>
<p>Everything we do is under a <strong>legal agreement</strong> that protects both you and the guest. We:</p>
<ul>
<li>
<p>Manage guest bookings</p>
</li>
<li>
<p>Handle payments and commissions</p>
</li>
<li>
<p>Maintain cleanliness, check-ins, and safety</p>
</li>
</ul>
<blockquote>
<p><strong>We grow with you &mdash; not at your cost.</strong></p>
</blockquote>
<ul>
<li>
<p>No overcharging if guests don&rsquo;t stay</p>
</li>
<li>
<p>Guest no-shows are verified by us</p>
</li>
<li>
<p>You can visit our local office in Pakistan</p>
</li>
<li>
<p>We offer phone support with our captains</p>
</li>
<li>
<p>We help with account setup, photo uploads, descriptions</p>
</li>
<li>
<p>We support your growth if you maintain standards</p>
</li>
<li>
<p>You may be listed as a top host in Pakistan</p>
</li>
<li>
<p>We help with <strong>government tourism panels</strong></p>
</li>
</ul>
<hr />
<h3>We Help You Grow &mdash; With Trust, Support &amp; Zero Overcharging</h3>
<p>At <strong>Yovho</strong>, we&rsquo;re not just a booking platform &mdash; we&rsquo;re your long-term <strong>business partner</strong>.</p>
<h3>Why Become a Partner with Yovho?</h3>
<p><strong>Your Property. Our Platform. Real Growth &mdash; Together.</strong></p>
<p>Yovho isn&rsquo;t just another booking site &mdash; it&rsquo;s a <strong>trusted hospitality network</strong> built on <strong>quality, fairness</strong>, and <strong>business support</strong>.</p>
<h3>What Do You Get as a Yovho Partner?</h3>
<h4>Verified Exposure to Real Travelers</h4>
<ul>
<li>
<p>Connects your property to <strong>families, tourists, overseas Pakistanis</strong>, and <strong>corporate guests</strong></p>
</li>
<li>
<p>Only verified, <strong>high-quality listings</strong> are shown</p>
</li>
</ul>
<h4>No Fake Charges or Hidden Fees</h4>
<ul>
<li>
<p><strong>Commission charged only if guest stays</strong></p>
</li>
<li>
<p>No-shows are verified</p>
</li>
<li>
<p>We handle all guest communication</p>
</li>
</ul>
<h4>Real Support, Not Just Emails</h4>
<ul>
<li>
<p><strong>Local office in Pakistan</strong> you can visit</p>
</li>
<li>
<p>Regular <strong>phone support via Yovho Captains</strong></p>
</li>
<li>
<p>Weekly performance follow-ups</p>
</li>
</ul>
<h4>We Help You Grow</h4>
<ul>
<li>
<p>Help with <strong>account creation</strong> and <strong>photo uploads</strong></p>
</li>
<li>
<p>Assist with <strong>description writing</strong> and <strong>pricing strategy</strong></p>
</li>
<li>
<p>Feature top performers in our <strong>"Top Hosts in Pakistan"</strong> campaigns</p>
</li>
<li>
<p>Help with <strong>government tourism opportunities</strong></p>
</li>
</ul>
<hr />
<h3>Quality Over Quantity</h3>
<p>We work only with properties that:</p>
<ul>
<li>
<p>Are <strong>clean, safe, and family-friendly</strong></p>
</li>
<li>
<p>Have <strong>professional service</strong> and <strong>trained staff</strong></p>
</li>
<li>
<p>Are <strong>legally registered</strong> with tourism departments</p>
</li>
</ul>
<blockquote>
<p>If you meet the standard, we send you bookings. <strong>Not excuses.</strong></p>
</blockquote>
<hr />
<h3>Ready to Grow With Yovho?</h3>
<p>Whether you're a <strong>hotel or homeowner</strong>, Yovho gives you <strong>bookings, trust, and support</strong> &mdash; without the usual platform headaches.</p>
<h3>Fair. Transparent. Business-focused.</h3>
<hr />
<h3>Guaranteed Support &mdash; Not Just Commission</h3>
<p>We ensure you receive a steady stream of <strong>verified bookings</strong>.</p>
<ul>
<li>
<p><strong>No fake or canceled booking charges</strong></p>
</li>
<li>
<p><strong>We verify no-shows ourselves</strong></p>
</li>
<li>
<p><strong>We don&rsquo;t keep unclear commission</strong></p>
</li>
<li>
<p>Communication via assigned <strong>Yovho Captain</strong></p>
</li>
</ul>
<hr />
<h3>You&rsquo;re Never Alone &mdash; Local Support in Pakistan</h3>
<ul>
<li>
<p>Registered <strong>branch office</strong> for in-person support</p>
</li>
<li>
<p>Available on <strong>phone, WhatsApp, or on-site visits</strong></p>
</li>
<li>
<p>Regular updates from your <strong>property manager</strong></p>
</li>
</ul>
<hr />
<h3>We Train &amp; Guide New Hosts</h3>
<p>New to digital bookings? We help with:</p>
<ul>
<li>
<p>Partner account creation</p>
</li>
<li>
<p>Photo uploads</p>
</li>
<li>
<p>Description writing</p>
</li>
<li>
<p>Full onboarding to make listings look <strong>professional</strong></p>
</li>
</ul>
<hr />
<h3>We Grow Your Business &mdash; If You Maintain the Standard</h3>
<p>If your property gets good reviews and maintains quality:</p>
<ul>
<li>
<p>We list you among <strong>Top Hosts in Pakistan</strong></p>
</li>
<li>
<p>Promote you through <strong>social media and campaigns</strong></p>
</li>
<li>
<p>Connect you with <strong>government tourism programs</strong></p>
</li>
</ul>
<blockquote>
<p>Your growth is our goal &mdash; <strong>if you follow Yovho&rsquo;s quality guidelines</strong></p>
</blockquote>
<hr />
<h3>You Focus on Hospitality &mdash; We Handle the Rest</h3>
<p>We manage:</p>
<ul>
<li>
<p>Bookings &amp; guest communication</p>
</li>
<li>
<p>Weekly inspections</p>
</li>
<li>
<p>Captain &amp; support team</p>
</li>
<li>
<p>Legal and operational work</p>
</li>
</ul>
<blockquote>
<p><strong>You deliver great hospitality &mdash; we handle the rest.</strong></p>
</blockquote>
<hr />
<h3>Beginner Training &amp; Onboarding Help</h3>
<p>For new partners, we offer:</p>
<ul>
<li>
<p>Step-by-step training to:</p>
<ul>
<li>
<p>Create great listings</p>
</li>
<li>
<p>Upload quality photos</p>
</li>
<li>
<p>Set seasonal pricing</p>
</li>
<li>
<p>Configure amenities and rules</p>
</li>
</ul>
</li>
</ul>
<hr />
<h3>Marketing Boost for Top Hosts</h3>
<p>Maintain high standards and we:</p>
<ul>
<li>
<p>Feature you in <strong>"Top Yovho Hosts of the Month"</strong></p>
</li>
<li>
<p>Promote you on <strong>social media and website</strong></p>
</li>
<li>
<p>Give more visibility to family, tourist, and corporate segments</p>
</li>
</ul>
<blockquote>
<p>More trust = <strong>More bookings</strong></p>
</blockquote>
<hr />
<h3>Our Promise to You</h3>
<p>&ldquo;<strong>We grow with you &mdash; not at your cost.</strong>&rdquo;</p>
<p>We believe in partnerships, not pressure.</p>
<ul>
<li>
<p>Long-term success</p>
</li>
<li>
<p>Income protection</p>
</li>
<li>
<p>Training and tools for growth</p>
</li>
</ul>
<h3>You Focus on Hospitality. We Handle the Rest.</h3>
<ul>
<li>
<p>Guest communication</p>
</li>
<li>
<p>Bookings</p>
</li>
<li>
<p>Weekly inspections</p>
</li>
<li>
<p>Support team</p>
</li>
<li>
<p>Legal and operations</p>
</li>
</ul>
<p><strong>We do the heavy lifting &mdash; you deliver great stays.</strong></p>


    </div>
  );
};

export default PartnerTerms;
